import { render } from "./app.vue?vue&type=template&id=de2cce16"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=de2cce16&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__